import { Box, Button, styled, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { colors } from "../utils/colors/Index";
import DashboardSquare from "../assets/svg/DashboardSquare";
import Crown from "../assets/svg/Crown";
import Logout from "../assets/svg/Logout";
import DashboardSquareOrange from "../assets/svg/DashboardSquareOrange";
import CrownOrange from "../assets/svg/CrownOrange";
import NewsSvg from "../assets/svg/NewsSvg";
import Faq from "../assets/svg/Faq";
import analytics from "../assets/svg/analytics";
import accountgray from "../assets/svg/accountgray";
import FeedGray from "../assets/svg/FeedGray";
import HistorySvg from "../assets/svg/historySvg";
import DiscountSvg from "../assets/svg/Discount";
import Monitoring from "../assets/svg/monitoring";
function SideBar() {
  const [activeButton, setActiveButton] = useState("dashboard");
  const Navigation = useNavigate();
  const location = useLocation();

  const handleSetActive = (value) => {
    if (value === "logout") {
      localStorage.removeItem("user");
      Navigation("/");
    } else {
      Navigation(value);
    }
  };

  const icons = [
    {
      icon: DashboardSquare,
      value: "/home",
      title: "Dashboard",
    },
    {
      icon: analytics,
      value: "/subscription",
      title: "Subscription",
    },
    {
      icon: Crown,
      value: "/addplans",
      title: "Add Plans",
    },
    {
      icon: DiscountSvg,
      value: "/coupon",
      title: "Coupons",
    },
    {
      icon: Monitoring,
      value: "/reports",
      title: "Reports",
    },
    {
      icon: HistorySvg,
      value: "/stock",
      title: "History",
    },

    {
      icon: FeedGray,
      value: "/feeds",
      title: "Feeds",
    },
    {
      icon: Faq,
      value: "/faq",
      title: "FAQ",
    },
  ];

  return (
    <Container>
      <SplitBox>
        {icons.map((icon, index) => (
          <Tooltip title={icon.title} placement="right">
            <StyledButton
              key={index}
              isActive={location === icon.value}
              onClick={() => handleSetActive(icon.value)}
            >
              <icon.icon
                color={location === icon.value ? "#E75300" : "black"}
              />
            </StyledButton>
          </Tooltip>
        ))}
      </SplitBox>
      <SplitBox sx={{ justifyContent: "center" }}>
        <StyledButton
          isActive={location === "logout"}
          onClick={() => handleSetActive("logout")}
        >
          <Logout />
        </StyledButton>
      </SplitBox>
    </Container>
  );
}

export default SideBar;
const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "calc(100vh - 64px)",
  backgroundColor: colors.background.primary,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
const SplitBox = styled(Box)({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  rowGap: "2rem",
  padding: "2rem 0rem",
});
const StyledButton = styled(Button)(({ isActive }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  borderLeft: isActive ? "2px solid #FFC200" : "2px solid transparent", // Placeholder to ensure width consistency
  background: isActive
    ? "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(250, 218, 213, 0) 20.77%, rgba(242, 155, 143, 0) 55.85%, rgba(255, 194, 0, 0.2) 98.19%)"
    : "transparent",
  color: isActive ? "#fff" : "inherit",
  "&:hover": {
    background:
      "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(250, 218, 213, 0) 20.77%, rgba(242, 155, 143, 0) 55.85%, rgba(255, 194, 0, 0.2) 98.19%)",
    color: "#fff",
    borderLeft: "2px solid #FFC200",
  },
  padding: "0.5rem",
  marginLeft: "0.5rem",
}));
